import { isRouteErrorResponse, Link, useRouteError } from 'react-router'
import { Button } from '@/shared/ui/button'

export function RouteErrorBoundary() {
  const error = useRouteError()

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex flex-col items-center justify-center h-full gap-4 p-8">
        <h1 className="text-4xl font-bold text-destructive">Error {error.status}</h1>
        <p className="text-lg text-muted-foreground">{error.statusText}</p>
        <Button asChild variant="outline">
          <Link to="/admin/dashboard">Volver al inicio</Link>
        </Button>
      </div>
    )
  }

  return (
    <div className="flex flex-col items-center justify-center h-full gap-4 p-8">
      <h1 className="text-2xl font-bold text-destructive">Algo salió mal</h1>
      <p className="text-muted-foreground">Ocurrió un error inesperado en esta sección.</p>
      <Button
        onClick={() => {
          window.location.reload()
        }}
        variant="outline"
      >
        Reintentar
      </Button>
    </div>
  )
}
